<template>
  <component
    v-if="params.url"
    :is="params.external ? 'a' : Link"
    ref="linkRef"
    :href="params.url"
    :target="params.external ? '_blank' : null"
    class="font-semibold text-blue-600 hover:text-blue-600 inline-flex items-center gap-0.5"
    :class="cellClass"
  >
    <span>{{ params.display ?? params.value }}</span>
    <ArrowTopRightOnSquareIcon
      v-if="params.external"
      class="w-4 h-4 -mt-0.5"
    />
  </component>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Link } from '@inertiajs/vue3'
import { useStopPropagation } from '@/Composables/stop-propagation'
import { ArrowTopRightOnSquareIcon } from '@heroicons-2/vue/16/solid'

const linkRef = ref(null)

// @Note: Prevents AG Grid from showing its custom right-click menu.
useStopPropagation({ linkRef })

/**
 * @typedef {Object} LinkCellParams
 * @property {String} display
 * @property {String} value
 * @property {String} url
 * @property {Boolean} external
 */
const props = defineProps({
  /** @type {LinkCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const cellClass = computed(() => {
  return props.params.cellClass || ''
})
</script>
